module.exports = __webpack_public_path__ + "img/quote-bottom.cb6b00e7.svg";